import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Design system first, app overrides second — CSS order is load-bearing.
import '@taskflow/ui/tokens.css';
import './styles/global.css';

import { App } from './app/App';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
